import utils from 'fancy-utils'
import _ from 'lodash'

function getUrlParams(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); //定义正则表达式
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

const token = getUrlParams('token')
if (token) {
  localStorage.setItem('accessToken', token)
  try {
    const user = getUrlParams('user')
    const info = JSON.parse(user)
    localStorage.setItem('userName', info.name)
    localStorage.setItem('authority', JSON.stringify(info.authority))
    if (token) {
      const query = _.omit(utils.parseQuery(window.location.href), ['token', 'user'])
      window.location.href = utils.addParam(`${window.location.origin}${window.location.pathname}`, query)
    }
  } catch (e) {

  }
}

var ACCESS_TOKEN = window.localStorage.getItem('accessToken')

var AUTHORITY = window.localStorage.getItem('authority')

var host = 'http://pre.chameleon.fancydsp.com'

if (window.location.hostname === 'test.chameleon.fancydsp.com') {
  host = 'http://pre.chameleon.fancydsp.com'
} else if (window.location.hostname === 'chameleon.fancydsp.com') {
  host = 'http://api.chameleon.fancydsp.com'
}

export default {
  HOST: host,
  UPLOAD_TOKEN: null,
  UPLOAD_DOMAIN: "",
  ACCESS_TOKEN: ACCESS_TOKEN,
  USER_NAME: localStorage.getItem('userName'),
  MAX_FILE_SIZE: 1024 * 1024 * 10,
  ApiKey: "9d7025e470ce896791603b45f0425527",
  UserKey: "1380B9C08262E4B0",
  AUTHORITY: AUTHORITY,
  FONT_LIST: [
  ]
}
